import React, { Component } from "react";
import { withRouter } from "react-router-dom";

class ScrollToTop extends Component {
	componentDidUpdate(prevProps) {
				
		if (this.props.location !== prevProps.location) {
						
			if (prevProps.location.pathname.toString().indexOf('/product/') !== -1 && this.props.location.pathname.toString().indexOf('/product/') !== -1 && this.props.location.pathname.toString().indexOf('to-top') === -1) {
				
			} else if (prevProps.location.pathname.toString().indexOf('/account/') !== -1 && this.props.location.pathname.toString().indexOf('/account/') !== -1) {
			
			} else if (this.props.location.pathname.toString().indexOf('collection') !== -1 || this.props.location.pathname.toString().indexOf('product-category') !== -1 || this.props.location.pathname.toString().indexOf('designer') !== -1 || this.props.location.pathname.toString().indexOf('search') !== -1) {
				if (prevProps.location.pathname.toString().indexOf('/product/') !== -1) {
				} else {
					window.scrollTo(0, 0);
				}
				
			} else {
				window.scrollTo(0, 0);
			}
		}
	}

	render() {
		return <React.Fragment />
	}
}

export default withRouter(ScrollToTop);